// extracted by mini-css-extract-plugin
export default {"block":"ql1lJ","readOnlyBlock":"SxuvR","item":"aDvNw","itemOrder":"XkVUq","itemOrderText":"T4qN3","itemText":"h73jz"};